import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { isDenebEnabled } from '@/const/flags'
import { aspidaClient } from '@/lib/aspida'
import { queryClient } from '@/lib/react-query'
import { useProxyStore } from '@/providers/proxyStore/ProxyStoreContext'

import { cartKeyFactory } from './key'

type MutationResponse = Awaited<ReturnType<typeof aspidaClient.v1.cart.$delete>>

type UseClearCartOptions = {
  config?: Omit<
    UseMutationOptions<MutationResponse, AxiosError, undefined>,
    'mutationFn'
  >
}

export const useClearCart = ({ config }: UseClearCartOptions) => {
  const { storeCode } = useProxyStore()

  const mutationFn = () => {
    if (isDenebEnabled && storeCode) {
      return aspidaClient.v1.employee.proxy_stores
        ._storeCode(storeCode)
        .cart.$delete()
    }
    return aspidaClient.v1.cart.$delete()
  }

  return useMutation({
    mutationFn,
    onSuccess: () => queryClient.invalidateQueries(cartKeyFactory.all),
    ...config,
  } as UseMutationOptions<MutationResponse, AxiosError, undefined>)
}
